'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*eslint no-console:0*/
// console helpers & polyfill for browsers which don't support it
//
(function () {
    if (!window.console) window.console = {
        log: function log() {},
        dir: function dir() {},
        error: function error() {}
    };

    var isDebug = false;

    window.console.setDebug = function (toggle) {
        ///<summary>turns debugging on</summary>
        isDebug = toggle !== false;
    };

    // In ie8 & 9 console.log is an object, not a function, so console.log.apply will not work. 
    // make sure we have a reference to a function
    // see http://stackoverflow.com/questions/5538972/console-log-apply-not-working-in-ie9
    var log = _typeof(console.log) == 'object' ? function (text) {
        console.log(text);
    } : console.log;

    window.console.debug = function (text) {
        /// <signature>
        /// <summary>logs the text to console, only if setDebug() has been turned on</summary>
        /// </signature>
        /// <signature>
        /// <summary>runs the function if debug is on</summary>
        /// </signature>

        if (isDebug && typeof text === 'function') text();else if (isDebug) log.apply(window.console, arguments);

        return isDebug;
    };
})();